module.exports = __webpack_public_path__ + "static/media/icon_1_3.37531fe3.svg";